module.exports = __webpack_public_path__ + "static/media/satellite.413ec2df.svg";